module.exports = __webpack_public_path__ + "static/media/Notifications.5e5314c3.md";